// 正式服务器
export const EV_HOST = "https://cloud.wnpower.cn:29015";
export const HOST = 'https://cloud.wnpower.cn:18002'
// export const HOST = 'http://127.0.0.1:14020'

// 本地服务器
// export const EV_HOST = "http://192.168.31.196:29015";
// export const HOST = "http://192.168.31.196:14020";

// 测试服务器
// export const EV_HOST = "http://36.140.29.65:29015";
// export const HOST = "http://36.140.29.65:14020";

export const RESTFUL_HOST = HOST + "";
export const CAPTCHA_HOST = HOST + "/servlet/captchaServlet";



// WEBPACK FOOTER //
// ./src/utils/host.js